'use strict';

/*@ngInject*/
module.exports = function ($rootScope, $uibModal, classifiersService, publicServicesService) {
    return {
        scope: {
            objectModalOpen: '=',
            viewMode: '=',
            services: '=',
            isScrollable: '=',
            isSearching: '=',
            showExpandedFilter: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller($scope) {
            var vm = this;
            vm.objects = [];
            vm.regionSelectionOpen = false;
            vm.objectsAmountForCategories = [];
            vm.filter = {
                types: []
            };

            $scope.$watch(function () {
                return angular.toJson(vm.filter.addresses);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    vm.getServicesBySearch();
                }
            });

            classifiersService.getServiceTypes().then(function (response) {
                vm.serviceTypes = response.data;
            });

            publicServicesService.servicesAmountForTypes().then(function (response) {
                vm.servicesAmountForTypes = response.data;
            });

            vm.rootScope = $rootScope;

            vm.getServicesCountByType = function (typeId) {
                var count = 0;
                angular.forEach(vm.servicesAmountForTypes, function (type) {
                    if (type.id === typeId) {
                        count = type.count;
                    }
                });
                return count;
            };

            vm.groupsValueChange = function (val) {
                var idx = vm.filter.groups.indexOf(val);
                if (idx > -1) {
                    vm.filter.groups.splice(idx, 1);
                } else {
                    vm.filter.groups.push(val);
                }
                vm.getServicesBySearch();
            };

            vm.categoryValueChange = function (val) {
                if (vm.showExpandedFilter) {
                    var idx = vm.filter.categories.indexOf(val);
                    if (idx > -1) {
                        angular.forEach(vm.objectCategories, function (category) {
                            if (category.id === val) {
                                if (category.subCategories) {
                                    angular.forEach(category.subCategories, function (subCategory) {
                                        if (vm.filter.subCategories.indexOf(subCategory.id) > -1) {
                                            vm.updateSubCategoryList(subCategory.id);
                                        }
                                    });
                                }
                            }
                        });
                        vm.filter.categories.splice(idx, 1);
                    } else {
                        vm.filter.categories.push(val);
                    }
                } else {
                    if (vm.filter.categories) {
                        var prevCat = vm.filter.categories[0];
                        vm.filter.categories = [];
                        vm.filter.subCategories = [];
                        if (val !== prevCat) {
                            vm.filter.categories.push(val);
                        }
                    } else {
                        vm.filter.categories.push(val);
                    }
                }
                vm.getServicesBySearch();
            };

            vm.updateSubCategoryList = function (val) {
                var idx = vm.filter.subCategories.indexOf(val);
                if (idx > -1) {
                    vm.filter.subCategories.splice(idx, 1);
                } else {
                    vm.filter.subCategories.push(val);
                }
            };

            vm.subCategoryValueChange = function (val) {
                vm.updateSubCategoryList(val);
                vm.getServicesBySearch();
            };

            vm.typeValueChange = function (val) {
                if (vm.showExpandedFilter) {
                    var idx = vm.filter.types.indexOf(val);
                    if (idx > -1) {
                        vm.filter.types.splice(idx, 1);
                    } else {
                        vm.filter.types.push(val);
                    }
                    vm.getServicesBySearch();
                }
            };

            vm.getServicesBySearch = function () {
                vm.isSearching = true;
                publicServicesService.getServicesBySearch(vm.filter, null).then(function (result) {
                    vm.isSearching = false;
                    vm.services = result.data;
                });
            };

            vm.$onInit = function () {
                vm.getServicesBySearch();
            };
        },
        template: require('./service-search-filter.directive.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/services/search_directives/service-search-filter.directive.js
 **/